import type { FC } from "react";
import { useEffect } from "react";

import { sendTelemetryEvent } from "@/lib/telemetry";
import type { ITelemetryButton } from "@Components/Button/TelemetryButton/TelemetryButton";
import TelemetryButton from "@Components/Button/TelemetryButton/TelemetryButton";
import type { PropsTelemetryCustom } from "@Components/Modules/Helpers";

import * as css from "./CashbackNumbers.module.css";

export interface ICashbackNumbersItem {
    numberInfo: string;
    description: string;
    button?: ITelemetryButton;
    buttonText?: string;
}

const CashbackNumbers: FC<
    PropsTelemetryCustom & {
        numbersList: ICashbackNumbersItem[];
    }
> = ({ numbersList: numberList, telemetryCustom }) => {
    useEffect(() => {
        sendTelemetryEvent(telemetryCustom);
    }, []);

    return (
        <div className={css.cashbackNumbersComponent}>
            {numberList.map((item: ICashbackNumbersItem, index: number) => (
                <div key={index} className={css.cashbackNumberItem}>
                    <div className={css.numberGradient}>{item.numberInfo}</div>
                    <div className={css.numberDescription}>{item.description}</div>
                    {item.buttonText && <TelemetryButton {...item.button}>{item.buttonText}</TelemetryButton>}
                </div>
            ))}
        </div>
    );
};

export default CashbackNumbers;
